import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { Observable, Subscription, debounceTime, distinctUntilChanged, firstValueFrom, forkJoin, lastValueFrom, of, startWith, switchMap } from 'rxjs';
import { QuotesService } from '../quotes.service';
import { IQuote } from '../quotes.interface';
import { QuotesHttpService } from '../quotes-http.service';
import { QuoteStatuses } from '../quotes.constants';
import { QuotesPDFModalComponent } from '../quotes-pdf-modal/quotes-pdf-modal.component';
import { Router } from '@angular/router';
import { ITaskProduct } from '../../../tasks-page/tasks/task.interface';
import { IClient, IClientsFilter } from '../../../clients-page/clients/clients.interface';
import { getEmptyDetailItem, IDetailItem } from '../../../../shared/components/detail-item/detail-item.interface';
import { MyErrorStateMatcher } from '../../../../shared/util/error-state-matcher';
import { ICompany } from '../../../companies-page/companies/companies.interface';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { ProductsService } from '../../../products-page/products/products.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { CompaniesService } from '../../../companies-page/companies/companies.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { TaskModalComponent } from '../../../tasks-page/tasks/task-modal/task-modal.component';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';

let self: any;

@Component({
  selector: 'app-quotes-modal',
  templateUrl: './quotes-modal.component.html',
  styleUrls: ['./quotes-modal.component.css']
})
export class QuotesModalComponent implements OnInit {
  quote!: IQuote;
  productItems: ITaskProduct[] = [];
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  action: string = '';
  customErrorStateMatcher = new MyErrorStateMatcher();

  // clients
  filter: IClientsFilter = { filters: { isDeleted: false }, sort: '', skip: 0, limit: 20 };
  $clients: Observable<any> = of();
  clientsTerm: string = '';

  // detail
  $products: Observable<any> = of();
  emptyDetailItem: IDetailItem = getEmptyDetailItem();

  // other
  companyId!: string;
  currentCompany!: ICompany;
  allDataToBilling: boolean = true;
  currentDate: any;
  categories: ICategory[] = [];
  quoteStatuses = QuoteStatuses;
  defaultTermAndCond: string = '';
  project!: string;

  subscriptions: Subscription;
  formValueChanged: boolean = false;
  constructedForm: boolean = false;
  refreshPage: boolean = false;

  constructor(
    public _ClientsService: ClientsService,
    public _ProductsService: ProductsService,
    private _dialogService: DialogService,
    private ref: ChangeDetectorRef,
    public dialogRef: MatDialogRef<any>,
    private _viewContainerRef: ViewContainerRef,
    private _dialog: MatDialog,
    public _CategoriesService: CategoriesService,
    private fb: UntypedFormBuilder,
    private _QuotesService: QuotesService,
    private _QuotesHttpService: QuotesHttpService,
    private _CompaniesService: CompaniesService,
    public _SettingsService: SettingsService,
    private _AuthService: AuthService,
    private _AlertService: AlertService,
    private _router: Router,
    private _UtilsService: UtilsService,
    private _broadcaster: Broadcaster,
  ) {
    self = this;
    this.dialog = dialogRef;
    this.subscriptions = new Subscription();
  }

  ngOnInit() {
    this.initializeComponent();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async initializeComponent() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.companyId = this._AuthService.companyId();

    this.loading = true;

    // this._SettingsService.getCompanySettingValue(SETTINGS.INVOICE_TERMS_AND_CONDITIONS)
    // .then((tc: string) => { this.defaultTermAndCond = tc });

    const sub = forkJoin({
      // quote: this._QuotesService.getQuote(this.quote),
      rawQuote: this._QuotesService.getRawQuote(this.quote),
      company: this._QuotesService.getCompany(this.companyId),
      client: this._QuotesService.getClient(this.quote.client),
      defaultTAndC: this._QuotesService.getSetting(SETTINGS.INVOICE_TERMS_AND_CONDITIONS),
    }).subscribe(async data => {

      if (data?.rawQuote?.[0]) {
        this.quote = data.rawQuote[0];
      }
      if (this.quote.details) {
        // for compatibility only
        this.quote.details.forEach(detail => {
          try { detail.taxPercentage = detail.taxPercentage ?? data.rawQuote[0].tasks[0].taxPercentage } catch (e) { }
        });
        // for compatibility only
      }


      this.currentCompany = data.company;
      this.quote.client = data.client;
      this.defaultTermAndCond = data.defaultTAndC;
      // this.quote = data.quote ?? this.quote;
      // if (!(this.quote?.details?.length > 0)) this.quote.details = [_.cloneDeep(this.emptyDetailItem)];
      // console.log('QuotesModalComponent', 'initializeComponent', this.quote);

      if (!(self.quote?.details?.length > 0)) this.quote.details = [getEmptyDetailItem()];

      this.action = this.quote?._id ? 'Modificar' : 'Crear';
      this.readOnly = !!this.quote?._id;

      await this.buildForm();
      // this.constructedForm = true;
      this.loading = false;

      sub.unsubscribe();
    });
    // disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      this.closeModal()
    });

    // REFACTOR: Has to wait for the form to be built for the first time
    setTimeout(() => {
      this.constructedForm = true;
    }, 4000);
    // REFACTOR

  }

  setEditable(value: boolean = true) {
    this.readOnly = !value;
  }

  get f() { return this.form.controls; }
  async buildForm() {
    // console.log(this.defaultTermAndCond)
    this.currentDate = new Date().toISOString().split('T')[0];
    let nextMonthDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()).toISOString().split('T')[0];
    let quoteDate = this.quote?.date ? new Date(this.quote.date).toISOString().split('T')[0] : this.currentDate;
    let quoteDueDate = this.quote?.dueDate ? new Date(this.quote.dueDate).toISOString().split('T')[0] : nextMonthDate;
    const category = _.get(this.quote, 'category');
    const categoryId = _.isArray(category) ? (category[0] || {})._id : (category || {})._id ?? undefined;
    let TAndC = this.quote?.termsAndConditions ? this.quote?.termsAndConditions : "";
    TAndC = this.action === "Crear" ? this.defaultTermAndCond : TAndC;

    this.form = this.fb.group({
      // details: this.fb.array(this.quote.details),
      client: [this.quote?.client, Validators.required],
      category: [categoryId],
      date: [quoteDate, Validators.required],
      dueDate: [quoteDueDate, Validators.required],
      description: [this.quote?.description || ""],
      termsAndConditions: [TAndC],
      tax: [this.quote?.tax || 0, Validators.required],
      // taxPercentage: [this.quote?.taxPercentage],
      //cost: [this.quote.cost || 0],
      subtotal: [this.quote?.subtotal || 0, Validators.required],
      total: [this.quote?.total || 0, Validators.required],
      status: [this.quote.status ?? this.quoteStatuses.QUOTED],
    });

    this.$clients = this.f['client'].valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          this.clientsTerm = val;
          return this.filterClients(val || '')
        })
      );

    this.subscriptions.add(this.form.valueChanges.subscribe(async event => await this.onFormValueChange(event)));
  }

  async onFormValueChange(event: any) {
    //console.log(this.constructedForm)
    if (this.constructedForm) {
      this.formValueChanged = true;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) return;
    let data: any = _.cloneDeep(this.form.value);
    data.company = this._AuthService.companyId();
    data.client = data.client?._id;
    data.details = _.cloneDeep(this.quote.details);

    let user = this._AuthService.profile();
    data.details.forEach((item: any) => {
      item.addBy = item.addBy ?? "admin";
      item.addByUser = _.get(item, 'addByUser._id') ?? user.id;
    });

    if (this.formValueChanged) {
      this.refreshPage = true;
    }

    if (this.project) data.project = this.project;

    if (this.quote._id) {
      data._id = this.quote._id;
      this._QuotesService.updateQuote(data).subscribe((quote: IQuote) => {
        this._broadcaster.broadcast('OnQuoteChange', true);
        this.setEditable(false);
        this.submitted = false;
        this.saving = false;
        this.quote = quote;
        this.initializeComponent();
      });
    } else {
      this._QuotesService.createQuote(data).subscribe((quote: IQuote) => {
        this._broadcaster.broadcast('OnQuoteChange', true);
        this.setEditable(false);
        this.submitted = false;
        this.saving = false;
        this.quote = quote;
        this.initializeComponent();
        this.dialog.close(quote);
      });
    }
  }

  async cancelSubmit() {
    if (!this.quote._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(false);
    this.initializeComponent();
  }

  cancelQuote() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Programar",
      message: "Esta seguro que desea Eliminar este Presupuesto?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this.f['status'].setValue(this.quoteStatuses.CANCELLED);
          this.updateQuote();
        }
      });

  }

  scheduleTask() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Programar Presupuesto",
      message: "¿Está seguro de que desea programar este Presupuesto?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          let config = new MatDialogConfig();
          config.width = '1300px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          const newTask = {
            status: this.quoteStatuses.QUOTED,
            client: this.quote.client,
            company: this.quote.company,
            products: _.cloneDeep(this.quote.details),
            quote: this.quote._id,
            project: this.quote?.project
          }
          self.taskDialogRef = this._dialog.open(TaskModalComponent, config);
          self.taskDialogRef.componentInstance.task = _.cloneDeep(newTask);
          self.taskDialogRef.componentInstance.readOnly = false;
          self.taskDialogRef.componentInstance.scheduling = true;

          self.taskDialogRef.afterClosed().subscribe(async (task: any) => {
            if (task && !task.project) {
              this.f['status'].setValue(this.quoteStatuses.SCHEDULED);
              await this.updateQuote();
            } else {
              this.f['status'].setValue(this.quoteStatuses.SCHEDULED);
              await this.updateQuote();
              this._broadcaster.broadcast('OnQuoteChange', true);
              this._broadcaster.broadcast('OnTaskChange', true);
            }

            if (task && !task.project) {
              this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-list'])
            } else {
              this.closeModal()
            }
          });
        }
      });
  }

  async updateQuote() {
    if (this.form.invalid) return;
    let data: any = _.cloneDeep(this.form.value);
    data.company = this._AuthService.companyId();
    data.client = data.client?._id;
    data.details = _.cloneDeep(this.quote.details);
    data._id = this.quote._id;
    const quote = await firstValueFrom(this._QuotesService.updateQuote(data));
    this.dialog.close(quote);
  }


  openQuote() {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(QuotesPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = this.quote;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  /*----------------- Client ------------------*/
  filterClients(val: string): Observable<any[]> {

    if (typeof val === 'string') {
      return this._ClientsService.getClients({
        sort: 'firstname lastname',
        skip: 0,
        limit: 5000,
        filters: { client: val, isDeleted: false },
        company: this._AuthService.companyId()
      });
    } else {
      return new Observable<any[]>;
    }
  }

  newClientSelected(client: IClient) {
    // this.f.client.setValue(_.get(client, 'firstname', '') + " " + _.get(client, 'lastname', ''))
    // this.f.client.setValue(client._id)
    // console.log(this.f.client.value)
  }

  displayClientsFn(client: IClient): string {
    if (client) {
      const firstName = client.firstname?.trim();
      const lastName = client.lastname ? " " + client.lastname.trim() : '';
      return firstName + lastName;
    } else {
      return '';
    }
  }

  openNewClientModal() {
    this.openClientModal(true);
  }

  openClientModal(newClient: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.clientDialogRef = this._dialog.open(ClientsModalComponent, config);
    self.clientDialogRef.componentInstance.client = !newClient ? this.f['client'].value : {};
    self.clientDialogRef.componentInstance.readOnly = false;

    const sub = self.clientDialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.quote.client = result;
        this.f['client'].setValue(result);
      }
      self.clientDialogRef = null;
      sub.unsubscribe();
    });
  }

  /*----------------- Detail ------------------*/
  onListChange(event: any) {
    //this.f.cost.setValue(event.totals.costsubtotal);
    this.f['subtotal'].setValue(event.totals.subtotal);
    this.f['tax'].setValue(event.totals.tax);
    this.f['total'].setValue(event.totals.total);
  }

  confirmExit() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Salir",
      message: "¿Está seguro de que desea salir? Los cambios no se guardarán",
      yesButtonLabel: 'Sí, deseo salir',
      noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          self.dialogRef.close();
        }
      });
  }

  closeModal() {
    if (!this.readOnly && this.formValueChanged) {
      this.confirmExit()
    } else {
      if (this.refreshPage) {
        self.dialogRef.close(this.quote);
      } else {
        self.dialogRef.close();
      }
    }
  }

  setAcceptedQuote() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Aceptar Presupuesto",
      message: "¿Desea aceptar este Presupuesto?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._QuotesService.updateQuote({ _id: this.quote._id, status: "ACCEPTED" }).subscribe((quote: IQuote) => {
            this._broadcaster.broadcast('OnQuoteChange', true);
            if(quote) this.initializeComponent();
          });
        }
      });
  }
}